import { Alert, CircularProgress, Snackbar } from "@mui/material";
import { isBefore } from "date-fns";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { StyledDataTable } from "../../../components/molecules/StyledDataTable";
import { convertStringToDate } from "../../../utils/date-utils";
import { FlexExpandingWrapper } from "../../ActivityLibrary/components/ActivityLibraryTable/styles";
import { ACCESS_LOG_COLUMNS } from "./columns";
import { AccessLogTableProps } from "./types";

export const AccessLogTable = ({ tableData, loading, error }: AccessLogTableProps): JSX.Element => {
  const [showError, setShowError] = useState<boolean>(false);

  useEffect(() => {
    setShowError(!!error);
  }, [error]);

  const getCsvData = () => {
    const headers = ACCESS_LOG_COLUMNS.map((col) => col.name);
    const csvRows = tableData
      .sort((rowA, rowB) =>
        isBefore(convertStringToDate(rowA.date) as Date, convertStringToDate(rowB.date) as Date)
          ? 1
          : -1
      )
      .map((row) => [row.viewedName, row.viewedByName, row.date]);
    return [headers].concat(csvRows);
  };

  if (loading) {
    return (
      <FlexExpandingWrapper>
        <CircularProgress />
      </FlexExpandingWrapper>
    );
  }

  return (
    <FlexExpandingWrapper>
      <StyledDataTable
        columns={ACCESS_LOG_COLUMNS}
        data={tableData}
        pagination
        paginationPerPage={20}
      />
      <br />
      <CSVLink data={getCsvData()}>Download data as a CSV</CSVLink>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={showError}
        onClose={() => setShowError(false)}
      >
        <Alert onClose={() => setShowError(false)} severity="error">
          Failed to fetch access log data.
        </Alert>
      </Snackbar>
    </FlexExpandingWrapper>
  );
};
